import {
  Record,
  String as RTString,
  Boolean as RTBoolean,
  Static,
  Array as RTArray,
  Number as RTNumber,
  Partial
} from 'runtypes';
import { DeepPartial } from 'utility-types';
import { buildService } from './decorated-service';
import config from '../../../config';

const TrustFundFormService = buildService(
  '/nasu-svc/service/change-ownership-form'
);

const TrustFundFormServiceArgs = Record({
  currentOwnership: RTArray(
    Partial({
      name: RTString,
      taxID: RTString
    })
  ),
  originatingAccounts: Partial({
    changeAllMatchingAccounts: RTBoolean,
    allocations: RTArray(
      Partial({
        accountNumber: RTString,
        agreementID: RTString,
        fundName: RTString,
        fundingPortion: RTString,
        allocationUnit: RTString,
        partialAmount: RTNumber
      })
    ),
    fundName: RTString
  }),
  receivingAccount: Partial({
    accountNumber: RTString,
    fundName: RTString
  })
});

export type StaticGetTrustFundFormArgs = Static<
  typeof TrustFundFormServiceArgs
>;

export type DeepPartialTrustFundFormArgs = DeepPartial<
  StaticGetTrustFundFormArgs
>;

export const postTrustFundFormData = (
  args: DeepPartialTrustFundFormArgs
): Promise<any> => {
  return TrustFundFormService.add(args, {
    responseType: 'application/pdf',
    headers: {
      'content-type': 'application/json',
      'content-disposition': 'inline',
      apikey: config('apiKey'),
      'x-trp-requested-with': 'XMLHttpRequest'
    },
    transformResponse: resp => resp.blob()
  });
};
